import { ThemeConfigInterface } from '../../interfaces/theme/theme-config';

export class ThemeConfigClass implements ThemeConfigInterface {
  baseTheme = 'Lara';
  darkMode = false;
  fontSize = 14;
  primaryColor = 'blue';
  surfaceDarkColor = 'neutral';
  surfaceLightColor = 'zinc';

  constructor(data?: ThemeConfigInterface) {
    if (data) {
      this.baseTheme = data.baseTheme;
      this.darkMode = data.darkMode;
      this.fontSize = data.fontSize;
      this.primaryColor = data.primaryColor;
      this.surfaceDarkColor = data.surfaceDarkColor;
      this.surfaceLightColor = data.surfaceLightColor;
    }
  }
}
